<template>
    <div>
      <el-table
            :data="[...tableData]"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '16px',
            }"
        >
         <el-table-column
            :label="'助学专业数'"
            prop="majorCount"
            align="center"
            header-align="center"
            v-if="type !== 'major'"
          >
            <template slot-scope="scope">
                <div style="color: #409eff">
                    {{ scope.row && scope.row.majorCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
          :label="type === 'school' ? '合作院校' : '合作机构'"
          :prop="type === 'school' ? 'schoolCount' : 'mhmCount'"
          align="center"
          header-align="center"
          v-if="type !== 'major'"
        >
          <template slot-scope="scope">
              <div style="color: #409eff">
                  {{
                      type === "school"
                          ? scope.row && scope.row.schoolCount
                          : scope.row && scope.row.mhmCount
                  }}
              </div>
          </template>
        </el-table-column>
        <el-table-column
            label="班级总数"
            prop="totalCount"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="color: #409eff">
                    {{ scope.row && scope.row.totalCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="合作院校"
            prop="schoolCount"
            align="center"
            header-align="center"
            v-if="type === 'major'"
        >
            <template slot-scope="scope">
                <div style="color: #D9001B">
                  {{ scope.row && scope.row.schoolCount}}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="合作机构"
            prop="mhmCount"
            align="center"
            header-align="center"
            v-if="type === 'major'"
        >
            <template slot-scope="scope">
                <div style="color: #D9001B">
                  {{scope.row && scope.row.mhmCount}}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="报名中"
            prop="signCount"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="color: #409eff">
                    {{ scope.row && scope.row.signCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="学习中"
            prop="learningCount"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="cursor: pointer; color: #4b7902">
                    {{ scope.row && scope.row.learningCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="未开始学习"
            prop="noLearnCount"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="已结束学习"
            prop="closeCount"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="学习中人数"
            prop="stuLearnNum"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="学习总人数"
            prop="stuTotalNum"
            align="center"
            header-align="center"
        ></el-table-column>
      </el-table>
    </div>
</template>

<script>
export default {
  props: ["type", "tableData"],
};
</script>

<style lang="scss" scoped>
.el-table {
  margin-top: 0px;
  font-weight: 700;
}
</style>